var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.scanResult.dispatch_request ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "3"
    }
  }, [_c('b-card', {
    staticClass: "mb-2",
    attrs: {
      "body-class": "pb-2"
    }
  }, [_c('b-card-title', [_vm._v("SCAN AFHAALCODE")]), _c('b-form', {
    attrs: {
      "inline": ""
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.processCode.apply(null, arguments);
      }
    }
  }, [_c('b-form-input', {
    staticClass: "mr-2 w-75 d-inline-block",
    attrs: {
      "autofocus": "",
      "autocomplete": "off",
      "disabled": _vm.isProcessing,
      "required": ""
    },
    model: {
      value: _vm.scannedCode,
      callback: function ($$v) {
        _vm.scannedCode = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "scannedCode"
    }
  }), _c('omni-button', {
    staticClass: "d-inline-block px-2 px-xl-3",
    attrs: {
      "is-processing": _vm.isProcessing,
      "disabled": _vm.isProcessing,
      "type": "submit",
      "variant": "success",
      "title": ""
    }
  }, [_vm._v("Scan")])], 1), _c('b-button', {
    staticClass: "px-0 mt-2",
    attrs: {
      "variant": "link",
      "disabled": _vm.isProcessing
    },
    on: {
      "click": function ($event) {
        _vm.isNoPickupCodeCardOpen = !_vm.isNoPickupCodeCardOpen;
      }
    }
  }, [_vm._v("Geen afhaalcode?")])], 1)], 1)], 1), _c('b-collapse', {
    model: {
      value: _vm.isNoPickupCodeCardOpen,
      callback: function ($$v) {
        _vm.isNoPickupCodeCardOpen = $$v;
      },
      expression: "isNoPickupCodeCardOpen"
    }
  }, [_c('b-card', [_c('b-card-title', [_vm._v("AFHAALCODE OPNIEUW VERSTUREN")]), _c('dispatch-requests', {
    key: JSON.stringify(_vm.dispatchRequestsToPickup),
    attrs: {
      "sales-order": _vm.salesOrder,
      "dispatch-requests": _vm.dispatchRequestsToPickup,
      "hide-actions": true
    },
    scopedSlots: _vm._u([{
      key: "extraActions",
      fn: function (data) {
        return [_c('span', {
          staticClass: "d-inline-block"
        }, [_vm._v(" Status laatste mail "), data.dispatchRequest.pickup_code_mail_sent_at ? _c('span', [_vm._v("(" + _vm._s(_vm._f("datetimeshort")(data.dispatchRequest.pickup_code_mail_sent_at)) + ")")]) : _vm._e(), _vm._v(": "), data.dispatchRequest.pickup_code_mail_status === undefined ? _c('font-awesome-icon', {
          attrs: {
            "icon": "spinner",
            "spin": ""
          }
        }) : data.dispatchRequest.pickup_code_mail_status === true ? _c('font-awesome-icon', {
          staticClass: "text-success font-size-lg",
          attrs: {
            "icon": "check-circle",
            "title": `Succesvol verzonden naar ${data.dispatchRequest.pickup_code_mail_address}`
          }
        }) : data.dispatchRequest.pickup_code_mail_status === false ? _c('font-awesome-icon', {
          staticClass: "text-danger font-size-lg",
          attrs: {
            "icon": "circle-xmark",
            "title": `Verzenden mislukt naar ${data.dispatchRequest.pickup_code_mail_address}`
          }
        }) : data.dispatchRequest.pickup_code_mail_status === null ? _c('font-awesome-icon', {
          staticClass: "text-secondary font-size-lg",
          attrs: {
            "icon": "circle-question",
            "title": `Status onbekend`
          }
        }) : _vm._e()], 1), _c('omni-button', {
          attrs: {
            "variant": "primary",
            "disabled": _vm.isResendingCode,
            "is-processing": _vm.isResendingCode,
            "title": ""
          },
          on: {
            "click": function ($event) {
              return _vm.resendCode(data.dispatchRequest);
            }
          }
        }, [_vm._v(" Verstuur afhaalcode ")])];
      }
    }], null, false, 1951219892)
  }), !_vm.dispatchRequestsToPickup.length ? _c('b-alert', {
    staticClass: "mb-0",
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_vm._v(" Geen leveringen gevonden om op te halen. ")]) : _vm._e()], 1)], 1), _vm.isInvalidCode ? _c('b-card', {
    attrs: {
      "body-class": "m-0 p-0"
    }
  }, [_c('b-alert', {
    staticClass: "mb-0",
    attrs: {
      "variant": "warning",
      "show": ""
    }
  }, [_vm._v(" Geen levering gevonden voor de ingegeven afhaalcode. ")])], 1) : _vm._e()], 1) : _c('div', [_c('b-card', [_c('b-card-title', [_vm._v("LEVERING GEVONDEN")]), !_vm.scanResult.was_already_picked_up ? _c('b-alert', {
    attrs: {
      "variant": "success",
      "show": ""
    }
  }, [_vm._v(" De afhaalcode is geldig en onderstaande order kan aan de klant worden meegegeven. ")]) : _c('b-alert', {
    attrs: {
      "variant": "warning",
      "show": ""
    }
  }, [_vm._v(" Let op: Deze levering is al opgehaald op: " + _vm._s(_vm._f("datetime")(_vm.scanResult.picked_up_at)) + " ")]), _c('dispatch-requests', {
    attrs: {
      "sales-order": _vm.salesOrder,
      "dispatch-requests": [_vm.scanResult.dispatch_request],
      "hide-actions": true,
      "show-replaced-as-normal": true
    }
  }), _c('b-button', {
    staticClass: "mt-2 float-right",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.finish.apply(null, arguments);
      }
    }
  }, [_vm._v(" Gedaan ")])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }